import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import Spinner from '@material-ui/core/CircularProgress';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Button from '@material-ui/core/Button';
import { isExpired, decodeToken } from "react-jwt";
import { unregister } from "../Interceptor.js";
var currentDate = moment(new Date());

localStorage.setItem('formaPago', 1);
localStorage.setItem('moneda', "COP");
localStorage.setItem('medioPago', 14);
localStorage.setItem('fechaPago', moment(currentDate).format('YYYY-MM-DDTHH:mm:ss'));
localStorage.setItem('fechaPagoTasa', moment(currentDate).format('YYYY-MM-DDTHH:mm:ss'));

var cont = 0;
var dataMonedas = [{}];
var dataFormasPago = [{}];
var dataMediosPago = [{}];

var formaPago = 0;
var medioPago = 0;

export default function PaymentForm() {


    const [loading, setLoading] = React.useState(false);

    const selectDataFormasPagoLoad = () => {

        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaFormasPago", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataFormasPago = result.basePresentationList;
                console.log(dataFormasPago);
                setDataFormasPago(dataFormasPago);
                var datafiscal = localStorage.getItem('datosEmpresaFiscales');
                var datosfis = JSON.parse(datafiscal);
                formaPago = datosfis.IdFormaPago;
                setFormasPago(formaPago);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataMonedasLoad = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaMonedas", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataMonedas = result.basePresentationList;
                console.log(dataMonedas);
                setDataMonedas(dataMonedas);
            })
            .catch(error => console.log('error', error));
    }
    
    const selectDataMediosPagoLoad = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaMediosPago", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataMediosPago = result.basePresentationList;
                console.log(dataMediosPago);
                setDataMediosPago(dataMediosPago);
                var datafiscal = localStorage.getItem('datosEmpresaFiscales');
                var datosfis = JSON.parse(datafiscal);

                medioPago = datosfis.IdMedioPago;
                setMediosPago(medioPago);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    const [formaPagoDef, setFormasPago] = React.useState(formaPago);
    const [medioPagodef, setMediosPago] = React.useState(medioPago);

    if (cont < 2) {
        selectDataFormasPagoLoad();
        selectDataMonedasLoad();
        selectDataMediosPagoLoad();
        cont = cont + 1;
    }

    const [dataTiposMonedas, setDataMonedas] = React.useState(dataMonedas);
    const [dataTiposFormasPago, setDataFormasPago] = React.useState(dataFormasPago);
    const [dataTiposMediosPago, setDataMediosPago] = React.useState(dataMediosPago);


    const [selectedDate, setSelectedDate] = React.useState(new Date());

    const [selectedDateTasa, setSelectedDateTasa] = React.useState(new Date());

    const handleDateChange = (date) => {
        setSelectedDate(date);
     //   localStorage.setItem('fechaPago', date);
        localStorage.setItem('fechaPago', moment(date).format('YYYY-MM-DDTHH:mm:ss'));
        console.log(localStorage.getItem('fechaPago'));
    };

    //handle NombreVendedor
    const handleNombreVendedor = (selectedOption) => {
        localStorage.setItem('nombreVendedor', selectedOption.target.value);
        console.log(localStorage.getItem('nombreVendedor'));
        setVendedor(selectedOption.target.value);
        handleSubmit();
    };

    //handle Tasa
    const handleTasa = (selectedOption) => {
        localStorage.setItem('Tasa', selectedOption.target.value);
        console.log(localStorage.getItem('Tasa'));
        setVendedor(selectedOption.target.value);
        handleSubmit();
    };

    const handleDateChangeTasa = (date) => {
        setSelectedDateTasa(date);
        //   localStorage.setItem('fechaPagoTasa', date);
        localStorage.setItem('fechaPagoTasa', moment(date).format('YYYY-MM-DDTHH:mm:ss'));
        console.log(localStorage.getItem('fechaPagoTasa'));
    };

    const [vendedor, setVendedor] = React.useState("");
    //handle Numero de Orden
    const handleNumOrden = (selectedOption) => {
        localStorage.setItem('numeroOrden', selectedOption.target.value);
        console.log(localStorage.getItem('numeroOrden'));
    };

    //handle Forma de Pago 
    const handleFormaPago = (selectedOption) => {
        localStorage.setItem('formaPago', selectedOption.target.value)
        console.log(localStorage.getItem('formaPago'));
        setFormasPago(selectedOption.target.value);
    };
    const [moneda, setMoneda] = React.useState("COP");
    //handle Moneda
    const handleMoneda = (selectedOption) => {
        localStorage.setItem('moneda', selectedOption.target.value)
        setMoneda(selectedOption.target.value);
        console.log(moneda)
        console.log(localStorage.getItem('moneda'));
    };

    //handle Medio de Pago 
    const handleMedioPago = (selectedOption) => {
        localStorage.setItem('medioPago', selectedOption.target.value)
        console.log(localStorage.getItem('medioPago'));
        setMediosPago(selectedOption.target.value);
    };

    const handleSubmit = () => {
        
    }


    return (
        <React.Fragment>
            <h5 style={{ textAlign: "center", fontSize: "20px" }}>Datos de Venta</h5>
            <Grid container spacing={3}>

                {/*<ValidatorForm
                    
                    onSubmit={handleSubmit}
                >
                    <h2>Simple form</h2>
                    <TextValidator
                        label="Email"
                        onChange={handleNombreVendedor}
                        name="email"
                        value={vendedor}
                        validators={['required', 'isEmail']}
                        errorMessages={['this field is required', 'email is not valid']}
                        
                    />
                    <br />
                    <Button type="submit">Submit</Button>
                    <br />
                </ValidatorForm>*/}
                        <Grid item xs={12} md={6}>
                    <TextField id="Employee" label="Nombre del Vendedor" type="text" fullWidth autoComplete="cc-name"
                        onChange={handleNombreVendedor} defaultValue="Nombre" inputProps={{ minLength: 0 }} required />
                            
                        </Grid>
                    
                <Grid item xs={12} md={6}>
                    <TextField
                        
                        id="orderNumber"
                        label="Numero de Orden"
                        fullWidth
                        autoComplete="cc-number"
                        onChange={handleNumOrden}
                    />
                </Grid>

            </Grid>
            <h5 style={{ marginTop: '20px', textAlign: "center", fontSize: "20px" }}>Datos de Pago</h5>
            <Grid container spacing={3} style={{ marginTop: '10px' }}>
                <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel required fullWidth>Forma de Pago</InputLabel>
                        <Select
                            labelId="demo-simple-select-required-label"
                            id="demo-simple-select-required"
                            fullWidth
                            label="Forma de Pago"
                            value={formaPagoDef}
                            onChange={handleFormaPago}>
                            {dataTiposFormasPago.map((tipo, index) =>
                                <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
                        </Select>
                    </FormControl>

                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel required fullWidth>Moneda</InputLabel>
                        <Select
                            labelId="demo-simple-select-required-label"
                            id="demo-simple-select-required"
                            fullWidth
                            label="Forma de Pago"
                            defaultValue={moneda ?? "COP"}
                            onChange={handleMoneda}>
                            {dataTiposMonedas.map((tipo, index) =>
                                <MenuItem key={index} value={tipo.InfoAdicional}>{tipo.Descripcion}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>

                
                    {moneda === "USD"
                    ?
                    <Grid container spacing={3} style={{ marginLeft: '5px', marginRight: '5px' }}>
                        <Grid item xs={12} md={6}>
                            <FormControl variant="outlined" fullWidth>
                                <TextField

                                    id="tasaCambio"
                                    label="Tasa de Cambio"
                                    fullWidth
                                    autoComplete="cc-number"
                                    onChange={handleTasa}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Grid container justify="space-around">
                                    <KeyboardDatePicker
                                        fullWidth
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Fecha de Tasa"
                                        format="MM/dd/yyyy"
                                        value={selectedDateTasa}
                                        onChange={handleDateChangeTasa}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </Grid>
                            </MuiPickersUtilsProvider>
                        </Grid>
                    
                    </Grid>
                        : <div />
                    }
                
                
                <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel required fullWidth>Medio de Pago</InputLabel>
                        <Select
                            labelId="demo-simple-select-required-label"
                            id="demo-simple-select-required"
                            fullWidth
                            label="Medio de Pago"
                            value={medioPagodef}
                            onChange={handleMedioPago}
                        >
                            {dataTiposMediosPago.map((tipo, index) =>
                                <MenuItem key={index} value={tipo.Codigo}>{tipo.Descripcion}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                            <KeyboardDatePicker
                                fullWidth
                                margin="normal"
                                id="date-picker-dialog"
                                label="Fecha de Pago"
                                format="MM/dd/yyyy"
                                value={selectedDate}
                                onChange={handleDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                    </MuiPickersUtilsProvider>
                        </Grid>

                <Grid item xs={12} sm={6} >
                    {loading && <Spinner color="secondary" />}
                </Grid>
                {/*<Grid item xs={12} md={12}>
        <TextField
            
            id="outlined-multiline-static"
            multiline
            rows={3}
            label="Condiciones de Pago"
            helperText="Escriba las condiciones de pago para la Factura."
            fullWidth
            autoComplete="cc-csc"
            variant="outlined"
          />
        </Grid>*/}

            </Grid>
        </React.Fragment>
    );
}
